const o="1.11.0";export{o as VERSION};
//# sourceMappingURL=data.js.map
